import { useEffect, useState } from "react";
import { config } from "../../config/config";
import { apiList, invokeApi } from "../../services/apiServices";
import { useCookies } from "react-cookie";
import { useUser } from "../../context/UserContext";

const useFetch = () => {
  const [cookies] = useCookies();
  const { user } = useUser();
  const [name, setName] = useState(user?.name || "");
  const [roles, setRoles] = useState(
    Array.isArray(user?.roles) ? user.roles.join(", ") : (user?.roles || "")
  );

  useEffect(() => {
    const handleGetUser = async () => {
      let id = null;
      const rawCookie = cookies[config.cookieName];
      if (rawCookie) {
        if (typeof rawCookie === "object" && rawCookie.loginUserId) {
          id = rawCookie.loginUserId;
        } else if (typeof rawCookie === "string") {
          try {
            id = JSON.parse(rawCookie).loginUserId;
          } catch (e) {}
        }
      }
      if (!id && user?.id) {
        id = user.id;
      }
      if (!id) return;

      try {
        const response = await invokeApi(apiList.getUser, { id });

        if (response?.status >= 200 && response?.status < 300) {
          if (response.data.responseCode === "200") {
            const userData = response.data.users;
            setName(userData.name || user?.name || "");
            const formattedRoles = Array.isArray(userData.roles)
              ? userData.roles.join(", ")
              : (userData.roles || "");
            setRoles(formattedRoles);
          }
        }
      } catch (error) {
        console.error("Error fetching user in useFetch:", error);
      }
    };

    handleGetUser();
  }, [cookies, user]);

  return {
    name: name || user?.name || "Administrator",
    roles: roles || (Array.isArray(user?.roles) ? user.roles.join(", ") : user?.roles) || "Super Admin"
  };
};

export default useFetch;

